import React from 'react';
import { Helmet } from 'react-helmet';

const sizes = {
  default: ['16x16', '32x32', '96x96'],
  apple: [
    '57x57',
    '60x60',
    '72x72',
    '76x76',
    '114x114',
    '120x120',
    '144x144',
    '152x152',
    '180x180',
  ],
};

const createHref = name =>
  `${window.etp.config.assetsUrl}img/favicons/${name}.png`;

const defaultIconProps = size => ({
  rel: 'icon',
  type: 'image/png',
  sizes: size,
  href: createHref(`favicon-${size}`),
});

const appleIconProps = size => ({
  rel: 'apple-touch-icon',
  sizes: size,
  href: createHref(`apple-touch-icon-${size}`),
});

const createDefaultLinks = () =>
  sizes.default.map(s => <link key={s} {...defaultIconProps(s)} />);

const createAppleLinks = () =>
  sizes.apple.map(s => <link key={s} {...appleIconProps(s)} />);

const Favicons = () => (
  <Helmet>
    {createDefaultLinks()}
    {createAppleLinks()}
  </Helmet>
);

export { createDefaultLinks, createAppleLinks };

export default Favicons;
